import { ChatButton } from './components/chat_button';

const chatButton = new ChatButton();

document.addEventListener("turbolinks:load", function () {
  chatButton.init();
});
